import React from 'react';
import { Element } from 'react-scroll';
import { useInView } from 'react-intersection-observer';
import './Home.scss';
import highlightHonest from '../assets/images/content/highlight-honest.svg';
import logoSvg from "../assets/images/logos/logo_only_gray.svg";
import Footer from "../components/Footer";
import s1 from '../assets/images/content/s1.png';
import s2 from '../assets/images/content/s2.png';
import s3 from '../assets/images/content/s3.png';
import ServiceCommitment from "../components/ServiceCommitment";

function Services() {
    // Set up inView triggers for each section
    const { ref: bannerRef, inView: bannerInView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const { ref: residentialRef, inView: residentialInView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const { ref: commercialRef, inView: commercialInView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const { ref: immigrationRef, inView: immigrationInView } = useInView({ triggerOnce: true, threshold: 0.2 });

    return (
        <div>
            <div ref={bannerRef}
                 className={`home-hero ak-primary-bg fade-in-section ${bannerInView ? 'animate-fade-up' : ''}`}>
                <div className="highlight-wrapper" style={{zIndex: 2}}>
                    <img src={highlightHonest} alt="" className="highlight-guiding-image"/>
                    <h1 className="semi-bold f-55 ak-white hero-title-h1 highlight-honest-text">
                        Our Services
                    </h1>
                </div>
            </div>

            {/* Service Commitments */}
            <div className="home-services-card page-top-spacing mx-auto">
                <img alt="" src={logoSvg} className={"services-svg"}/>
                <Element name="home-story">
                    {/* Real Estate Law Section */}
                    <div ref={residentialRef}
                         className={`fade-in-section ${residentialInView ? 'animate-fade-up' : ''}`}>
                        <Element id="residential">
                            <ServiceCommitment
                                id="01"
                                name="Residential Real Estate"
                                description="Comprehensive assistance with residential property transactions."
                                fullDescription="Comprehensive assistance with residential property transactions, ensuring a smooth and legally sound process from purchase agreements to closing. We provide expert guidance on contracts, title searches, mortgage financing, property disclosures, and legal due diligence to safeguard your investment. Whether you are buying, selling, or refinancing a home, our team ensures your interests are protected, potential risks are mitigated, and all necessary legal documentation is accurately prepared. With a client-focused approach, we streamline negotiations and address any legal complexities, giving you confidence in every step of your real estate journey."
                                image={s1} imageWidth={342} imageHeight={199}
                                sectionId="residential"
                            />
                        </Element>
                    </div>

                    {/* Commercial Real Estate Law Section */}
                    <div ref={commercialRef} className={`fade-in-section ${commercialInView ? 'animate-fade-up' : ''}`}>
                        <Element id="commercial">
                            <ServiceCommitment
                                id="02"
                                name="Commercial Real Estate"
                                description="Providing strategic legal support in commercial property and business asset transactions."
                                fullDescription="Providing strategic legal support in commercial property and business asset transactions, ensuring seamless negotiations and compliance with all legal requirements. We assist with purchase and sale agreements, lease negotiations, zoning and land use regulations, financing structures, and risk management to protect your investment. Whether you are acquiring office space, retail property, industrial facilities, or mixed-use developments, our expertise ensures that every contract is meticulously reviewed and structured to align with your business goals. Our client-centric approach streamlines the transaction process, mitigates legal risks, and secures favorable terms, giving you the confidence to move forward with your real estate investments."
                                image={s2} imageWidth={341} imageHeight={276}
                                sectionId="commercial"
                            />
                        </Element>
                    </div>

                    {/* Immigration Law Section */}
                    <div ref={immigrationRef}
                         className={`fade-in-section ${immigrationInView ? 'animate-fade-up' : ''}`}>
                        <Element id="immigration">
                            <ServiceCommitment
                                id="03"
                                name="Immigration"
                                description="Expert guidance through complex immigration processes for individuals and families."
                                fullDescription="Expert guidance through complex immigration processes for individuals and families, offering tailored legal solutions to help you achieve residency, work authorization, and citizenship. Our services cover visa applications, permanent residency (PR) pathways, family sponsorship, work permits, and appeals for denied applications. We navigate the evolving legal landscape to provide strategic advice, ensuring compliance with immigration policies while maximizing opportunities for success. Whether you are seeking to reunite with loved ones, pursue career opportunities, or establish permanent roots, our dedicated team simplifies the process, minimizes delays, and advocates for your best interests every step of the way."
                                image={s3} imageWidth={365} imageHeight={255}
                                sectionId="immigration"
                            />
                        </Element>
                    </div>
                </Element>
            </div>

            <Footer/>
        </div>
    );
}

export default Services;
